import { render, staticRenderFns } from "./payForm.vue?vue&type=template&id=4c397d81"
import script from "./payForm.vue?vue&type=script&lang=js"
export * from "./payForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports